<template>
  <vs-chip :color="backgroundColor || 'white'" class="mr-1 border border-solid" :class="{'text-dark': !backgroundColor, 'border-none': backgroundColor}">
    <AnchoredTitle :title="title"/><span class="ml-1" v-if="showCount">({{count}}x)</span>
  </vs-chip>
</template>

<script>

export default {
  components: {},
  props: ['title', 'count', 'backgroundColor'],
  data () {
    return {}
  },
  computed: {
    showCount () {
      return !!this.count && this.count > 1
    }
  },
  methods: {
  }
}
</script>
